import React from 'react';
import {
  MedicineBoxOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import './footer.css';

export function Footer() {
  return (
    <footer
      style={{
        background: '#ffffff',
        borderTop: '1px solid #e2e8f0',
        padding: '28px 16px',
        marginTop: 'auto',
        color: '#64748b',
        fontSize: 13,
      }}
    >
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="footer-inner">
          {/* Thương hiệu */}
          <div style={{ maxWidth: 340 }}>
            <div className="footer-row">
              <MedicineBoxOutlined style={{ color: '#005537', fontSize: 18 }} />
              <span style={{ fontWeight: 700, color: '#1e293b' }}>daotaonhathuoc.com</span>
            </div>
            <p style={{ margin: '8px 0 0', lineHeight: 1.6 }}>
              Nền tảng kiến thức &amp; kỹ năng thực chiến cho các nhà thuốc, quầy thuốc — vận hành
              bởi Thế Thảo Pharma.
            </p>
          </div>

          <div className="footer-divider" />

          {/* Liên hệ */}
          <div>
            <div style={{ fontWeight: 700, color: '#1e293b', marginBottom: 8 }}>Liên hệ</div>
            <div className="footer-row" style={{ marginBottom: 6 }}>
              <PhoneOutlined style={{ color: '#005537' }} />
              <a href="tel:0812539539" style={{ color: '#475569', textDecoration: 'none' }}>
                Hotline / Zalo: 0812.539.539
              </a>
            </div>
            <div className="footer-row">
              <EnvironmentOutlined style={{ color: '#005537' }} />
              <span>60B Nguyễn Huy Tưởng, Thanh Xuân, Hà Nội</span>
            </div>
          </div>

          <div className="footer-divider" />

          {/* Cộng đồng */}
          <div>
            <div style={{ fontWeight: 700, color: '#1e293b', marginBottom: 8 }}>Cộng đồng</div>
            <a
              href="https://www.facebook.com/groups/934460299578977"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-community-btn"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 8,
                padding: '9px 18px',
                borderRadius: 999,
                border: '1px solid #005537',
                color: '#005537',
                fontWeight: 600,
                textDecoration: 'none',
                whiteSpace: 'nowrap',
              }}
            >
              <TeamOutlined /> Nhà Thuốc &amp; Dược Sĩ 5.0
            </a>
          </div>
        </div>


      </div>
    </footer>
  );
}
